import React, { Component } from "react";
import { fieldPropTypes } from "redux-form/lib/propTypes";
import $ from "jquery";

import "./CustomPriceField.scss";
import isEqual from "lodash/isEqual";

/**
 * CustomPriceField
 */
class CustomPriceField extends Component {
  static propTypes = {
    ...fieldPropTypes
  };

  static defaultProps = {};

  componentWillMount() {
    $(document, ".productCollectionMemberId").on("change", this.onChange);
  }

  componentWillUnmount() {
    $(document, ".productCollectionMemberId").off("change", this.onChange);
  }

  shouldComponentUpdate(nextProps) {
    // for some reason this does not work in the connect() "areMergedPropsEqual" option
    return !isEqual(this.props, nextProps);
  }

  onChange = e => {
    if ($(e.target).val() === "0") {
      // customPrice
      $("#form-control-customPrice").focus();
    }
  };

  render() {
    const { input, meta, t, ...rest } = this.props;

    const hasError = meta.error && meta.touched;

    return (
      <div className={`CustomPriceField ${rest.id}-container${hasError ? " has-danger" : ""}`}>
        <div>
          <div>
            {t("Own price")}
            <input {...rest} className={`${rest.className}${hasError ? " is-invalid" : ""}`} {...input} />
          </div>
          {hasError && <div className="invalid-feedback">{meta.error}</div>}
        </div>
      </div>
    );
  }
}

export default CustomPriceField;
